if(!customElements.get('marquee-logo-list')) {
    class MarqueeLogoList extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.addEventListener('click', event => {
                const dataImage = event.target.closest('img');
                if (!dataImage) return;
                const url = dataImage.dataset.url;
                if (!url) return;
                window.open(url, '_blank');
            })
        }
    }
    customElements.define('marquee-logo-list', MarqueeLogoList);
}